import { post } from 'common/apiClient';

export type FilterPayload = {
  requestType?: string;

  searchText?: string;
  paymentId?: number;
  laNumber?: string;
  merchantID?: string;
  orderId?: string;
  fromDate?: string;
  paymentRefNo?: string;
  paymentRequestID?: number | string;
  numValue?: number | string;
  toDate?: string;
  sourceApplicationName?: string;
  requestPurpose?: string;
  paymentPurpose?: string;
  Status?: string;
  requestStatus?: string;
  Username?: string;
  pageNo?: number;
  pageSize?: number;
  isExtract?: boolean;
  type?: number;
  sourceId?: string;
};

export type PaymentPagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: PaymentListData[];
};

export type PaymentListData = {
  RequestType: any;
  PaymentRequest: any;
  PAYMENTREQUESTID: any;
  LANUMBER: any;
  LOANTYPE: any;
  ACCOUNT_ID: any;
  SOURCEAPPLICATIONNAME: any;
  REQUESTPURPOSE: any;
  MODE: any;
  PAYMENTPURPOSE: any;
  MERCHANTID: any;
  AMOUNT: any;
  RequestStatus: any;
  NEW_STATUS: any;
  PAYMENTREF: any;
  REFTRANSACTION: any;
  OrderId: any;
  PaymentId: any;
  FUNDINGACCOUNT: any;
  BANKCODE: any;
  CURRENCY: any;
  FAVOURNAME: any;
  VERIFICATIONREASON: any;
  AGENTREJECTREMARKS: any;
  PAYMENTREQUESTDATETIME: any;
  PENNANTRECEIPTDATE: any;
  PENNANTRECEIPTNO: any;
  AUTH_CODE: any;
  BYAGENT: any;
  REMARKS: any;
  PAYMENTREQUESTERROR: any;
  PENNANTERRORDESC: any;
  WEBHOOKERROR: any;
  Action: any;
  IMPACTMODE: any;
  GATEWAYNAME: any;
};
export type AuditResponse = {
  data: AuditLog[];
};

export type AuditLog = {
  LANumber: string;
  Event: string;
  EventDateTime: string;
  ErrorDescription: string;
  JsonFormate: string;
  JsonResult: string;
};
export type RequestHistoryPagedResponse = {
  data: PaymentPagedList;
};
export type SelectPayload = {
  SKey: string;
};
export type SelectResponse = {
  data: SelectList[];
};

export type SelectList = {
  SKey: string;
  SValue: string;
  SText: string;
};

export const getPaymentRequestHistoryList = (payload?: FilterPayload) =>
  post<any>('/dashboardmodule/getPaymentRequestHistory', payload);
